
import { getColors } from '../../utils'

const getModalStyles = () => {
  const colors = getColors();
  return {
    header: {
      display: "flex",
      alignItems: "center",
      padding: "var(--Spacing-Spacing-20, 20px) 16px",
      gap: "16px",
      alignSelf: "stretch",
    },
    title: {
      display: "flex",
      flex: "1 0 0",
      overflow: "hidden",
    },
    body: {
      display: "flex",
      padding: "20px",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "var(--Spacing-Spacing-16, 16px)",
      alignSelf: "stretch",
    },
    footer: {
      display: "flex",
      padding: "var(--Spacing-Spacing-24, 24px) 20px",
      justifyContent: "center",
      alignItems: "center",
      gap: "var(--Spacing-Spacing-16, 16px)",
      borderTop: colors.border,
      flexShrink: 0,
      flexWrap: "wrap",
    },
    image: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "8px",
      width: "100%"
    }
  };
}
export default getModalStyles;
